import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import GatewayRequests from 'app/requests/Gateway/Gateway.requests'
import GatewayForm from '../GatewayForm'

const GatewayCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    return (
        <GatewayForm
            onSuccess={onSuccess}
            requestParam={GatewayRequests.create()}
        />
    )
}

export default GatewayCreate
